<template lang="pug">
section
    BaseHeader(
        :titulo='$t("mensagens.territorio.titulo")',
        :exibeBotao='false',
        :voltarPara='true'
    )
    div(style='padding: 25px')
        form-territorio(
            @update='onForm',
            @validate='event => (validate.isForm = event)',
            :cultivo='cultivo',
            :fields='informacao'
        )
        informacao-especial(
            @add='adicionarLayer',
            @remover='removerMap',
            :is-edit='!!$route.query.id',
            :layers='layersMaps',
            :geometria='geometryDesenho',
            :informacoes='informacoesEspeciais'
        )
        enlace-persona(
            @update='setEnlace',
            @delete='setDelete',
            :papeis='papeis',
            :representantes='representantes',
            :options='params.representantes'
        )
        upload-arquivos(
            @add='setUpload',
            @delete='setDeleteArquivo',
            :items='params.arquivosTerritorio'
        )
        modal-sucesso(:is-active='false')
        .flex.justify-content-end
            el-button(
                type='primary',
                style='margin-top: 15px',
                :disabled='validateForm',
                @click='handlerSubmit()'
            ) {{ $t('mensagens.territorio.territorioAr.salvar') }}
    ModalConsolidacao(
        :show='showModalConsolidarArea',
        @close='closeModal',
        @confirmaConsolidacao='confirmaConsolidacao'
    )
    ModalAvisoValidacaoRenspaAR(
        :show='showModalAvisoValidacaoRenspa',
        @close='closeModalValidacaoRenspa',
        @confirma='confirmaValidacaoRenspa'
    )
</template>
<script>
import territorioService from '@/services/TerritorioService';
import CulturaService from '@/services/CulturaService';
import representanteService from '@/services/RepresentanteService';
import BaseHeader from '@/components/BaseHeader';
import FormTerritorio from '@/components/territorio/FormTerritorioAr.vue';
import InformacaoEspecial from '@/components/territorio/InformacaoEspecial.vue';
import EnlacePersona from '@/components/territorio/EnlacePersona.vue';
import UploadArquivos from '@/components/territorio/UploadArquivosAr.vue';
import ModalConsolidacao from '@/components/territorio/ModalConsolidacaoAR.vue';
import ModalAvisoValidacaoRenspaAR from '@/components/territorio/ModalAvisoValidacaoRenspaAR.vue';
import ModalSucesso from '@/components/territorio/ModalSucesso.vue';
import mapaEstilos from '@/utils/mapa/mapa.estilos';
import LocalidadeService from '@/services/LocalidadeService';

export default {
    name: 'CadastrarEditarTerritorioAR',
    components: {
        BaseHeader,
        FormTerritorio,
        InformacaoEspecial,
        EnlacePersona,
        UploadArquivos,
        ModalConsolidacao,
        ModalSucesso,
        ModalAvisoValidacaoRenspaAR
    },
    data() {
        return {
            informacao: {
                nome: null,
                cuit: null,
                provincia: null,
                renspa: null,
                informacoesAgricolas: []
            },
            territorio: {},
            geometryDesenho: {},
            geometriaRenspaJaExistente: {},
            params: {
                representantes: [],
                comercializacoes: [],
                arquivosTerritorio: []
            },
            cultivo: [],
            papeis: [],
            representantes: [],
            layersMaps: [],
            validate: {
                isForm: false,
                isInformation: false,
                isEnlace: false,
                isUpload: true
            },
            informacoesEspeciais: {},
            showModalConsolidarArea: false,
            showModalAvisoValidacaoRenspa: false
        };
    },
    created() {
        this.getCultura();
        this.getPapeis();
        this.getRepresentante();

        const id = this.$route.query.id;

        if (id) {
            this.getTerritorio(id);
        }
    },
    methods: {
        removerMap(index) {
            this.layersMaps.splice(index, 1);
        },
        adicionarLayer(layer) {
            const indice = this.layersMaps.length;
            this.layersMaps.push(layer);
            this.postGeometria(layer.geometry, indice);
        },
        onForm(value) {
            this.informacao = { ...value };
        },
        setEnlace(value) {
            this.params.representantes.push(value);
        },
        setDelete(index) {
            this.params.representantes.splice(index, 1);
        },
        setDeleteArquivo(index) {
            this.params.arquivosTerritorio.splice(index, 1);
        },
        setUpload(value) {
            this.params.arquivosTerritorio.push(value);
        },
        async getTerritorio(id) {
            try {
                const { data } = await territorioService.findById(id);

                this.informacao.renspa = data.renspa;
                this.informacao.nome = data.nome;
                this.informacao.cuit = data.cuit;
                this.informacao.provincia = data.provincia;
                this.informacao.informacoesAgricolas =
                    data.informacaoAgricolaPY.map(item => {
                        return {
                            area: item.areaPlantada,
                            media: item.produtividade,
                            cultivo: this.cultivo.find(
                                ({ id }) => id === item.idCultura
                            )?.nomeTraduzido,
                            idCultura: item.idCultura
                        };
                    });

                this.params.representantes = data.representantes.map(item => {
                    return {
                        papel: {
                            nome: item.papelAR.nome,
                            id: item.papelAR.id
                        },
                        pessoa: {
                            nome: item.nomeRazaoSocial,
                            id: item.id
                        }
                    };
                });
                this.params.arquivosTerritorio = data.arquivosTerritorio.map(
                    item => {
                        return {
                            ...item,
                            name: item.nomeArquivo,
                            size: item.fileSize
                        };
                    }
                );

                this.setMapGeometry({
                    geometria: data.geometria,
                    areaHa: data.areaHa
                });
            } catch (error) {
                throw new Error({ cause: error });
            }
        },
        async handlerSubmit() {
            if (this.layersMaps.length > 1) {
                this.showModalConsolidarArea = true;
                return;
            }
            const renspa = this.informacao.renspa.replace(/[^\d]+/g, '');
            const validacaoRenspa = await this.validacaoTerritorioRenspa(
                renspa
            );
            if (!validacaoRenspa) {
                this.showModalAvisoValidacaoRenspa = true;
                return;
            }

            if (this.$route.query.id) {
                const possuiImpedimentoAtualizarTerritorio =
                    await this.preValicadaoAtualizacaoAr();
                if (!possuiImpedimentoAtualizarTerritorio) {
                    this.updateAr();
                }
            } else {
                this.insertAr();
            }
        },
        async insertAr(usarGeometriaRenspaJaExistente) {
            try {
                const params = {
                    ...this.informacao,
                    ...this.params,
                    cuit: this.informacao.cuit.replace(/[^\d]+/g, ''),
                    renspa: this.informacao.renspa.replace(/[^\d]+/g, ''),
                    arquivosTerritorio: this.params.arquivosTerritorio,
                    geoJson: usarGeometriaRenspaJaExistente
                        ? this.geometriaRenspaJaExistente
                        : this.layersMaps[0].geometry,
                    representantes: this.params.representantes.map(item => {
                        return { idPapel: item.papel.id, id: item.pessoa.id };
                    }),
                    informacoesAgricolas:
                        this.informacao.informacoesAgricolas.map(item => {
                            return {
                                areaPlantada: item.area,
                                produtividade: item.media,
                                idCultura: item.idCultura
                            };
                        })
                };

                await territorioService.addArgentina(params);

                this.$notify.success({
                    message: this.$t(
                        'mensagens.territorio.territorioAdicionadoSucesso'
                    )
                });
                this.$router.push({ name: 'TerritorioArgentina' });
            } catch (erro) {
                this.$notify.error({
                    message: erro.response.data.message.includes(
                        this.$t('mensagens.territorio.geometriaNaoValida')
                    )
                        ? this.$t(
                              'mensagens.territorio.erroCadastroTerritorioGeometriaInvalida'
                          )
                        : erro.response.data.message
                });
            }
        },
        async updateAr(usarGeometriaRenspaJaExistente) {
            try {
                const params = {
                    ...this.informacao,
                    ...this.params,
                    cuit: this.informacao.cuit.replace(/[^\d]+/g, ''),
                    renspa: this.informacao.renspa.replace(/[^\d]+/g, ''),
                    arquivosTerritorio: this.params.arquivosTerritorio,
                    geoJson: usarGeometriaRenspaJaExistente
                        ? this.geometriaRenspaJaExistente
                        : this.layersMaps[0].geometry,
                    representantes: this.params.representantes.map(item => {
                        return { idPapel: item.papel.id, id: item.pessoa.id };
                    }),
                    informacoesAgricolas:
                        this.informacao.informacoesAgricolas.map(item => {
                            return {
                                areaPlantada: item.area,
                                produtividade: item.media,
                                idCultura: item.idCultura
                            };
                        })
                };
                const id = this.$route.query.id;

                await territorioService.updateArgentina(params, id);

                this.$notify.success({
                    message: this.$t(
                        'mensagens.territorio.territorioAdicionadoSucesso'
                    )
                });
                this.$router.push({ name: 'TerritorioArgentina' });
            } catch (erro) {
                this.$notify.error({
                    message: erro.response.data.message.includes(
                        this.$t('mensagens.territorio.geometriaNaoValida')
                    )
                        ? this.$t(
                              'mensagens.territorio.erroCadastroTerritorioGeometriaInvalida'
                          )
                        : erro.response.data.message
                });
            }
        },
        async preValicadaoAtualizacaoAr() {
            try {
                const params = {
                    renspa: this.informacao.renspa.replace(/[^\d]+/g, ''),
                    geoJson: this.layersMaps[0].geometry
                };
                const id = this.$route.query.id;

                const req = await territorioService.preValicadaoAtualizacaoAr(
                    params,
                    id
                );

                if (req.data) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.territorio.erroPreValidacaoAtualizarTerritorio'
                        )
                    });
                }

                return req.data;
            } catch (erro) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.erroPreValidacaoAtualizarTerritorio'
                    )
                });
            }
        },
        async getCultura() {
            try {
                const { data } = await CulturaService.buscarCultura();
                this.cultivo = data;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },
        async getPapeis() {
            try {
                const { data } = await territorioService.listaPapeis();
                this.papeis = data;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },
        async getRepresentante() {
            try {
                const { data } =
                    await representanteService.listarRepresentante();
                this.representantes = data;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },
        setMapGeometry({ geometria, areaHa }) {
            const territorio = {
                type: 'AREA_CONSOLIDADA',
                codigo: 'AREA_CONSOLIDADA',
                area_ha: areaHa,
                geometry: geometria,
                identificadorGeometria: new Date().getTime()
            };

            this.mostrarTerritorioNoMapa(territorio);

            this.postGeometria(geometria, 0);
        },
        mostrarTerritorioNoMapa(territorio) {
            const layerTerritorio = {
                ...territorio,
                style: mapaEstilos.Geometria.imovelRuralCandidato,
                name: territorio.identificadorGeometria,
                geoJson: territorio.geometry,
                departamento: '',
                distrito: ''
            };

            this.layersMaps.push(layerTerritorio);
        },
        async postGeometria(geometria, index) {
            try {
                const { data } =
                    await LocalidadeService.buscarLocalidadesPorGeometria(
                        geometria
                    );
                this.layersMaps[index].distrito = data.distritoNome;
                this.layersMaps[index].departamento = data.departamentoNome;
                this.geometryDesenho = geometria;
            } catch (error) {
                throw new Error({ cause: error });
            }
        },

        closeModal() {
            this.showModalConsolidarArea = false;
        },

        closeModalValidacaoRenspa() {
            this.showModalAvisoValidacaoRenspa = false;
        },

        confirmaConsolidacao() {
            let listGeometryToSend = {
                geometries: []
            };
            this.layersMaps.forEach(item => {
                listGeometryToSend.geometries.push({ ...item.geometry });
            });
            territorioService
                .consolidaTerritorio(listGeometryToSend)
                .then(response => {
                    if (response.status === 200) {
                        const identificadorGeometria = new Date().getTime();

                        const territorio = {
                            identificadorGeometria: identificadorGeometria,
                            type: response.data.tipo,
                            codigo: 'AREA_CONSOLIDADA',
                            area_ha: response.data.areaTotal,
                            geometry: response.data.geometry,
                            geoJson: response.data.geometry,
                            departamento: '',
                            distrito: ''
                        };

                        this.layersMaps = [];

                        this.layersMaps.push(territorio);

                        this.$notify.success({
                            message: this.$t(
                                'mensagens.territorio.territorioConsolidadoComSucesso'
                            )
                        });

                        this.showModalConsolidarArea = false;

                        this.handlerSubmit();
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.territorio.erroAoConsolidarTerritorios'
                            )
                        });
                    }
                });
        },

        confirmaValidacaoRenspa() {
            if (this.$route.query.id) {
                this.updateAr(true);
            } else {
                this.insertAr(true);
            }
        },

        async validacaoTerritorioRenspa(codigoRenspa) {
            const idTerritorio = this.$route.query.id
                ? this.$route.query.id
                : 0;

            try {
                const { data } =
                    await territorioService.validacaoTerritorioRenspa(
                        codigoRenspa,
                        idTerritorio
                    );

                if (data && data.renspaUtilizado) {
                    this.geometriaRenspaJaExistente = data.geometria;
                    return false;
                }

                return true;
            } catch (error) {
                throw new Error({ cause: error });
            }
        }
    },
    computed: {
        validateForm() {
            const validations = [
                this.validate.isForm,
                this.params.representantes.length > 0,
                this.layersMaps.length > 0
            ];

            return !Object.values(validations).every(item => item);
        }
    }
};
</script>
